import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import SoundCloudPlayer from './SoundCloudPlayer';
import YouTubePlayer from './YouTubePlayer';

import {
  youtubeParser,
  getMiliseconds,
  getSeconds
} from '../helpers/PlayerHelper';

export default class Player extends Component {
  constructor(props) {
    super(props);
  }

  static propTypes = {
    url: PropTypes.string.isRequired,
    isPodcast: PropTypes.bool,
    timePosition: PropTypes.string,
    autoPlay: PropTypes.bool,
    visual: PropTypes.bool,
    startHours: PropTypes.number,
    startMinutes: PropTypes.number,
    startSeconds: PropTypes.number
  };

  static defaultProps = {
    isPodcast: false,
    timePositon: null,
    autoPlay: false,
    url: null,
    startHours: null,
    startMinutes: null,
    startSeconds: null,
    visual: false // Changes the player's look (image to the left, or as background of player)
  };

  render() {
    const { url, visual, autoPlay, isPodcast } = this.props;

    const shouldAutoPlay = Boolean(autoPlay);

    if (isPodcast) {
      const miliseconds = getMiliseconds(this.props);
      return (
        <SoundCloudPlayer
          url={url}
          visual={visual}
          autoPlay={shouldAutoPlay}
          startAt={miliseconds}
        />
      );
    }
    let videoId = youtubeParser(url);
    const seconds = getSeconds(this.props);
    return (
      <YouTubePlayer videoId={videoId} startAt={seconds} autoPlay={autoPlay} />
    );
  }
}
